<template>
  <div
    @click.stop="updateValue"
    :class="{ disabled: disabled }"
    class="flex-checkbox"
  >
    <div :class="{ 'active-checkbox': isActive }" class="c-checkbox">
      <svg
        v-if="isActive"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        class="transform origin-center"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M5 13l4 4L19 7"></path>
      </svg>
    </div>
    <span>{{ label }}</span>
  </div>
</template>

<script>
export default {
  name: "Checkbox",
  props: {
    value: [String, Number, Boolean],
    name: String,
    disabled: Boolean,
    label: String,
    options: Array,
  },
  data() {
    return {
      items: this.options || [true, false],
      isActive: false,
    };
  },
  watch: {
    value: {
      handler(newVal) {
        this.isActive = newVal === this.items[0];
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    updateValue() {
      if (!this.disabled) {
        const newValue =
          this.value === this.items[0] ? this.items[1] : this.items[0];
        this.$emit("input", newValue);
        this.onchange(newValue);
      }
    },

    onchange(value) {
      this.$emit("onchange", value);
    },
  },
};
</script>

<style scoped>
.c-checkbox {
  width: 20px;
  height: 20px;
  border: 1px solid var(--dark-light);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border 0.2s ease, background 0.2s ease;
  cursor: pointer;
}

.c-checkbox.active-checkbox {
  border-color: var(--primary);
  background-color: var(--primary);
  color: var(--white);
}

.flex-checkbox {
  display: flex;
  align-items: center;
  gap: 8px;
  user-select: none;
  cursor: pointer;
  width: fit-content;
}

.flex-checkbox:hover .c-checkbox {
  border-color: var(--primary);
  color: var(--white);
}

.flex-checkbox.disabled {
  cursor: not-allowed;
  opacity: 0.6;
  pointer-events: none;
}

.flex-checkbox span {
  padding-top: 3px;
}
</style>
